const createMyLocationController = function ({
  $ = window.jQuery,
  $body = ($ ? $('body') : null),
  L = window.L,
  baseSwal = window.Swal,
  fnT = function (key) { return String(key || '') },
  fnGetMap = function () { return null },
  navigatorRef = (typeof navigator !== 'undefined' ? navigator : null),
} = {}) {

  let myLocationMarker = null
  let myLocationActive = false
  let myLocationLocateTimer = null
  let myLocationFallbackTried = false

  const clearLocateTimer = function () {
    if (!myLocationLocateTimer) return
    clearTimeout(myLocationLocateTimer)
    myLocationLocateTimer = null
  }

  const setButtonActive = function (active) {
    myLocationActive = !!active
    if ($body && typeof $body.find === 'function') {
      $body.find('[data-leaf-my-location]').toggleClass('active', myLocationActive)
    }
  }

  const applyLatLng = function (latlng) {
    const map = fnGetMap()
    if (!latlng || !map || !L || typeof L.marker !== 'function') return
    clearLocateTimer()
    if (!myLocationMarker) {
      myLocationMarker = L.marker(latlng).addTo(map)
    } else {
      myLocationMarker.setLatLng(latlng)
      if (!map.hasLayer(myLocationMarker)) myLocationMarker.addTo(map)
    }
    setButtonActive(true)
    if (map.getBounds && !map.getBounds().contains(latlng)) {
      map.panTo(latlng)
    }
  }

  const formatGeoError = function (error) {
    const code = Number(error && error.code)
    const rawMsg = String((error && error.message) || '').trim()
    if (code === 1) return fnT('geo.permission_denied')
    if (code === 2) return fnT('geo.position_unavailable')
    if (code === 3) return fnT('geo.timeout')
    if (/only secure origins|secure context|https/i.test(rawMsg)) {
      return fnT('geo.secure_context_required')
    }
    if (rawMsg) return fnT('geo.failed_prefix') + ' ' + rawMsg
    return fnT('geo.location_failed')
  }

  const tryBrowserFallback = function () {
    if (!myLocationActive || myLocationFallbackTried) return
    myLocationFallbackTried = true
    if (!navigatorRef || !navigatorRef.geolocation || typeof navigatorRef.geolocation.getCurrentPosition !== 'function') {
      setButtonActive(false)
      if (baseSwal && typeof baseSwal.fire === 'function') {
        baseSwal.fire({ icon: 'error', title: fnT('geo.browser_unavailable') })
      }
      return
    }
    const fnOnSuccess = function (position) {
      if (!myLocationActive) return
      const coords = position && position.coords ? position.coords : null
      if (!coords || !Number.isFinite(coords.latitude) || !Number.isFinite(coords.longitude)) {
        setButtonActive(false)
        if (baseSwal && typeof baseSwal.fire === 'function') {
          baseSwal.fire({ icon: 'error', title: fnT('geo.location_failed') })
        }
        return
      }
      if (!L || typeof L.latLng !== 'function') return
      applyLatLng(L.latLng(coords.latitude, coords.longitude))
    }
    const fnOnErrorFinal = function (error) {
      if (!myLocationActive) return
      setButtonActive(false)
      if (baseSwal && typeof baseSwal.fire === 'function') {
        baseSwal.fire({ icon: 'error', title: formatGeoError(error) })
      }
    }
    navigatorRef.geolocation.getCurrentPosition(
      fnOnSuccess,
      function (error) {
        if (!myLocationActive) return
        // Unknown provider errors are often transient; retry once with relaxed settings.
        const code = Number(error && error.code)
        if (code === 2 || /unknown error acquiring position/i.test(String((error && error.message) || ''))) {
          navigatorRef.geolocation.getCurrentPosition(
            fnOnSuccess,
            fnOnErrorFinal,
            { enableHighAccuracy: false, timeout: 20000, maximumAge: 30000 }
          )
          return
        }
        fnOnErrorFinal(error)
      },
      { enableHighAccuracy: true, timeout: 12000, maximumAge: 0 }
    )
  }

  return {
    clearLocateTimer: clearLocateTimer,
    setButtonActive: setButtonActive,
    applyLatLng: applyLatLng,
    tryBrowserFallback: tryBrowserFallback,
    isActive: function () { return myLocationActive },
    setFallbackTried: function (nextValue) { myLocationFallbackTried = !!nextValue },
    getMarker: function () { return myLocationMarker },
    setMarker: function (nextMarker) { myLocationMarker = nextMarker || null },
    setLocateTimer: function (nextTimer) { myLocationLocateTimer = nextTimer || null }
  }
}

export {
  createMyLocationController
}
